let __webpack_public_path__ = process.env.NODE_ENV === 'production' || Shopify.designMode ? window.assetsPath : '/assets/'

import './styles/main.css';
import { recoverCart } from '@/scripts/store/cart-recovery';
import { runCartPopupRules } from '@/scripts/store/cart-popup';
import { observeAffirm } from '@/scripts/store/affirm';
import { 
  ScrollButton, 
  ProductToolList, 
  EmployeeList, 
  ImageBannerScrollOverlay, 
  ScrollAnimation, 
  AssociatedVariants, 
  AnimatedCanvas, 
  CartNote,
  SeeItInPerson,
  ProductVariations,
  SystemCarouselItem,
  AjaxForm,
  KustomerForm 
} from '@/scripts/store/custom-web-components';
import { VisibilityRules } from '@/scripts/store/visibility-rules';
import { setupGrowthbook } from "@/scripts/store/growthbook";

//Design System Components
// import '@decked/decked-design-system/dist/components/input/input.js';
// import '@decked/decked-design-system/dist/components/button/button.js';
// import '@decked/decked-design-system/dist/components/select/select.js';
// import '@decked/decked-design-system/dist/components/option/option.js';

import '@/scripts/lit/vehicle-picker';
//import "@lottiefiles/lottie-player";

//setup growthbook
setupGrowthbook();

//recover cart using param
recoverCart();

//run cart popup rules
document.addEventListener('DOMContentLoaded', function(){
  // const cartReturnVariant = window.experiments.get('cart-return')?.variant;
  // switch(cartReturnVariant){
  //   case '1':
  //     runCartPopupRules();
  //     break;
  //   case '2':
  //     runCartPopupRules({popover: true});
  //     break;
  // }
  runCartPopupRules();
});

//bind affirm observer
observeAffirm();

if (!window.customElements.get("visibility-rules")) {
  window.customElements.define('visibility-rules', VisibilityRules);
}
if (!window.customElements.get("see-it-in-person")) {
  window.customElements.define('see-it-in-person', SeeItInPerson);
}
if (!window.customElements.get("product-tool-list")) {
  window.customElements.define('product-tool-list', ProductToolList);
}
if (!window.customElements.get("scroll-button")) {
  window.customElements.define('scroll-button', ScrollButton);
}
if (!window.customElements.get("employee-list")) {
  window.customElements.define('employee-list', EmployeeList);
}
if (!window.customElements.get("image-banner-scroll-overlay")) {
  window.customElements.define('image-banner-scroll-overlay', ImageBannerScrollOverlay);
}
if (!window.customElements.get("scroll-animation")) {
  window.customElements.define('scroll-animation', ScrollAnimation);
}
if (!window.customElements.get("associated-variants")) {
  window.customElements.define('associated-variants', AssociatedVariants);
}
if (!window.customElements.get("animated-canvas")) {
  window.customElements.define('animated-canvas', AnimatedCanvas);
}
if (!window.customElements.get("cart-line-note")) {
  window.customElements.define('cart-line-note', CartNote);
}
if (!window.customElements.get("product-variations")) {
  window.customElements.define('product-variations', ProductVariations);
}
if (!window.customElements.get("system-carousel-item")) {
  window.customElements.define('system-carousel-item', SystemCarouselItem);
}
if (!window.customElements.get("ajax-form")) {
  window.customElements.define('ajax-form', AjaxForm);
}
if (!window.customElements.get("kustomer-form")) {
  window.customElements.define('kustomer-form', KustomerForm);
}


const deckedLogo = `
#===================================================================\\\\
#  #######     #######     ######     ##   ##    #######   #######   \\\\ 
#  ##     ##   ##        ##      ##   ## ##      ##        ##     ##  # 
#  ##     ##   ######    ##           ### #      ######    ##     ##  #  
#  ##     ##   ##        ##      ##   ##  ##     ##        ##     ##  #  
#  #######     #######     ######     ##    ##   #######   #######   // 
#===================================================================//
`
console.log(deckedLogo);